import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import { useSelector } from "react-redux";
import PatientService from "../../Services/PatientService";
import { Spin } from "antd";

const ProcedureList = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const patientData = useSelector((state) => state?.auth?.patientData);
  console.log(patientData);

  useEffect(() => {
    if (patientData?.patientId) {
      fetchProcedures();
    }
  }, [patientData]);

  const countries = [
    { country_Id: "IN", country_Name: "India" },

    // Add more countries as needed
  ];

  const fetchProcedures = async () => {
    try {
      let payload = {
        patientId: patientData?.patientId,
        status: 1,
      };
      const response = await PatientService.procedureReqList(payload);
      console.log("Procedure Requests Response:", response);
      setData(response?.data || []);
    } catch (error) {
      console.error("Error fetching procedure requests:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container w-[100%] mx-auto">
        {loading ? (
          <div className="flex justify-center items-center py-6 mt-20">
            <Spin />
          </div>
        ) : (
          <table className="w-full border-2 mt-10 rounded-full">
            <thead className="bg-primaryColor text-white w-full">
              <tr>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Patient Name
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Mobile
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Email
                </th>

                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  City
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Country
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Service Type
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Service Description
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Planned Date
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Preferred Hospital
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((record, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                  >
                    <td className="p-3 whitespace-nowrap border-b">
                      <div className="font-sans font-normal">
                        <span>{record.patientName}</span>
                      </div>
                      <div className="text-[13px] font-sans">
                        {record.patientId}
                      </div>
                    </td>

                    <td className="p-3 whitespace-nowrap">{record.mobile}</td>
                    <td className="p-3 whitespace-nowrap">{record.email}</td>
                    <td className="p-3 whitespace-nowrap">{record.city}</td>

                    <td className="p-3 whitespace-nowrap">
                      {countries.find(
                        (country) => country.country_Id === record.country
                      )?.country_Name || "-"}
                    </td>

                    <td className="p-3 whitespace-nowrap">
                      {record.plannedService}
                    </td>

                    <td className="p-3 whitespace-nowrap">
                      {record.serviceDescription}
                    </td>

                    <td className="p-3 whitespace-nowrap">
                      {record.plannedDate}
                    </td>

                    <td className="p-3 whitespace-nowrap">
                      {record.preferredHospital || "-"}
                    </td>

                    <td className="p-3 whitespace-nowrap">
                      <span
                        className={`px-4 py-2 rounded-md text-sm ${
                          record.status === 1
                            ? "bg-[#31E4A81A] text-green-600"
                            : "bg-[#FF60601A] text-red-600"
                        }`}
                      >
                        {record.status === 1 ? "Completed" : "Pending"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="10"
                    className="p-4 text-center text-gray-500 font-sans"
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
};

export default ProcedureList;
